import React, { useState } from 'react';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import { Link } from "react-router-dom";

import app1 from "../app1.png";
import app2 from "../app2.png";
import app3 from "../app3.png";

const Page3 = (props) => {
  const [step4, setStep4] = useState(false);
  const [step5, setStep5] = useState(true);
  const [trackingNumber, setTrackingNumber] = useState('');
  const [loading, setLoading] = useState(false); // Added Loading State

  const schools = [
    'Islamia Collegiate School Peshawar',
    'Peshawar Public School Peshawar (Boys + Girls)',
    'Fazal Haq College Mardan',
    'Akram Khan Durrani College Bannu',
    'Mufti Mehmood School and College D.I. Khan',
    'Abbottabad Public School Abbottabad',
    'University Wensam School and College D.I. Khan',
    'Agriculture University Public School and College',
    'Exceisior School & College Swat (B&G)',
  ];

  const [preferences, setPreferences] = useState({
    pref1: props.applicant.pref1 || 'Select',
    pref2: props.applicant.pref2 || 'Select',
    pref3: props.applicant.pref3 || 'Select',
    pref4: props.applicant.pref4 || 'Select',
    pref5: props.applicant.pref5 || 'Select'
  });

  const convertToUrduNumber = (num) => {
    const urduNumbers = ['پہلی', 'دوسری', 'تیسری', 'چوتھی', 'پانچوی'];
    return urduNumbers[num - 1];
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    const newPreferences = { ...preferences, [name]: value };
    setPreferences(newPreferences);
    props.setApplicant({ ...props.applicant, [name]: value });
  };

  const getOptionsForSelect = (prefKey) => {
    const allSelectedValues = Object.values(preferences);
    return (
      <>
        <option value="Select">Select Preference</option>
        {schools.map((school, index) => {
          const isSelectedElsewhere = allSelectedValues.includes(school) && preferences[prefKey] !== school;
          if (isSelectedElsewhere) return null;
          return <option key={index} value={school}>{school}</option>;
        })}
      </>
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    for (let i = 1; i <= 5; i++) {
      const val = props.applicant[`pref${i}`];
      if (!val || val === 'Select') {
        toastr.error(`Preference ${i} must be provided`);
        return;
      }
    }

    setLoading(true); // Set loading to true
    try {
      const response = await fetch('https://etea.online/apply/api_coe/saveCandidateInfo1', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(props.applicant),
      });
      const json = await response.json();
      if (json.Status) {
        setStep4(true);
        setTrackingNumber(json.CNIC);
        setStep5(false);
      } else {
        toastr.error(json.Message);
      }
    } catch (error) {
      toastr.error('Error fetching data.');
    } finally {
      setLoading(false); // Set loading to false
    }
  };

  return (
    <div style={{ padding: '40px 15px', maxWidth: '900px', margin: '0 auto', fontFamily: "'Segoe UI', Roboto, sans-serif" }}>
      <style>
        {`
          .success-card { background: #ffffff; border-radius: 20px; box-shadow: 0 20px 40px rgba(0,0,0,0.1); overflow: hidden; animation: slideIn 0.5s ease-out; }
          @keyframes slideIn { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
          
          .header-gradient { background: linear-gradient(135deg, #1d976c 0%, #93f9b9 100%); padding: 40px; text-align: center; color: white; }
          
          .step-box { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 12px; padding: 25px; margin-bottom: 20px; display: flex; align-items: flex-start; gap: 15px; }
          
          .circle-num { background: #1d976c; color: white; min-width: 35px; height: 35px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 16px; }
          
          .urdu-text { font-family: 'Tahoma', sans-serif; direction: rtl; text-align: right; color: #475569; display: block; margin-top: 10px; font-size: 15px; line-height: 1.6; width: 100%; }
          
          .app-gallery { display: flex; gap: 20px; margin: 25px 0; justify-content: flex-start; flex-wrap: wrap; }
          
          .app-container { text-align: center; width: 170px; }
          
          .app-step-img { 
            width: 100%; 
            height: auto; 
            border-radius: 12px; 
            border: 3px solid #e2e8f0; 
            box-shadow: 0 4px 10px rgba(0,0,0,0.05);
            transition: transform 0.3s;
          }
          .app-step-img:hover { transform: scale(1.03); border-color: #1d976c; }
          
          .app-label { font-size: 12px; font-weight: 700; color: #64748b; margin-top: 10px; text-transform: uppercase; letter-spacing: 0.5px; }

          .tracking-box { background: rgba(255,255,255,0.2); backdrop-filter: blur(8px); padding: 15px 30px; border-radius: 12px; display: inline-block; margin-top: 20px; border: 1px solid rgba(255,255,255,0.3); }
          
          .btn-home { background: #1d976c; color: white !important; padding: 15px 45px; border-radius: 50px; text-decoration: none !important; font-weight: 700; display: inline-block; transition: 0.3s; box-shadow: 0 4px 15px rgba(29,151,108,0.3); }
          .btn-home:hover { background: #167a57; transform: translateY(-2px); box-shadow: 0 6px 20px rgba(29,151,108,0.4); }
          
          .pref-card { background: #fff; padding: 35px; border-radius: 20px; box-shadow: 0 10px 30px rgba(0,0,0,0.05); border: 1px solid #f1f5f9; }
          .form-control-custom { border-radius: 10px; height: 50px; border: 2px solid #e2e8f0; width: 100%; padding: 0 15px; font-size: 14px; transition: border-color 0.3s; }
          .form-control-custom:focus { border-color: #1d976c; outline: none; }
        `}
      </style>

      {step4 && (
        <div className="success-card">
          <div className="header-gradient">
            <div style={{ fontSize: '60px', marginBottom: '10px' }}>✅</div>
            <h2 style={{ margin: 0, fontWeight: '800', fontSize: '30px', letterSpacing: '-0.5px' }}>Application Saved Successfully!</h2>
            <div className="tracking-box">
              <span style={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '1.5px', fontWeight: '600' }}>Your Tracking ID / CNIC</span>
              <div style={{ fontSize: '26px', fontWeight: '900' }}>{trackingNumber}</div>
            </div>
          </div>

          <div style={{ padding: '40px' }}>
            <h5 style={{ color: '#1e293b', marginBottom: '25px', fontWeight: '800', borderLeft: '4px solid #1d976c', paddingLeft: '15px' }}>
              Next Steps to Complete Registration (اگلے اہم مراحل)
            </h5>

            <div className="step-box">
              <div className="circle-num">1</div>
              <div style={{ flex: 1 }}>
                <strong style={{ color: '#1e293b', fontSize: '18px' }}>Upload Photo via ETEA Mobile App</strong>
                <p style={{ margin: '8px 0', color: '#64748b', fontSize: '15px', lineHeight: '1.5' }}>
                  Download the ETEA Mobile App. Use your <b>CNIC</b> (without dashes) as both your <b>Username</b> and <b>Password</b> to login and upload your profile picture.
                </p>

                <div className="app-gallery">
                  <div className="app-container">
                    <img src={app1} className="app-step-img" alt="Step 1" />
                    <p className="app-label">1. Tap 'More'</p>
                  </div>
                  <div className="app-container">
                    <img src={app2} className="app-step-img" alt="Step 2" />
                    <p className="app-label">2. Secure Login</p>
                  </div>
                  <div className="app-container">
                    <img src={app3} className="app-step-img" alt="Step 3" />
                    <p className="app-label">3. Profile Upload</p>
                  </div>
                </div>

                <span className="urdu-text">
                  ایٹا ایپ ڈاؤن لوڈ کریں اور اپنی  تصویر اپلوڈ کریں۔ لاگ ان کے لیے اپنا شناختی کارڈ نمبر (بغیر ڈیش) یوزر نیم اور پاس ورڈ دونوں جگہ لکھیں۔
                </span>
              </div>
            </div>

            <div className="step-box">
              <div className="circle-num">2</div>
              <div style={{ flex: 1 }}>
                <strong style={{ color: '#1e293b', fontSize: '18px' }}>Download & Pay Fee Challan</strong>
                <p style={{ margin: '8px 0', color: '#64748b', fontSize: '15px', lineHeight: '1.5' }}>
                  After uploading the photo, visit the <b>"Already Applied"</b> section on this website to generate and print your bank fee voucher.
                </p>
                <span className="urdu-text">تصویر اپلوڈ کرنے کے بعد ویب سائٹ سے چالان ڈاؤن لوڈ کریں اور کسی بھی مقررہ بینک میں فیس جمع کروائیں۔</span>
              </div>
            </div>

            <div style={{ textAlign: 'center', marginTop: '40px' }}>
              <Link to="/" className="btn-home">Finish & Go Home</Link>
            </div>
          </div>
        </div>
      )}

      {step5 && (
        <form onSubmit={handleSubmit}>
          <div className="pref-card">
            <h4 style={{ color: '#1e293b', fontWeight: '800', borderBottom: '2px solid #f1f5f9', paddingBottom: '20px', marginBottom: '30px' }}>
              Desired Institution Preferences
            </h4>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '30px' }}>
              {[1, 2, 3, 4, 5].map(num => (
                <div key={num} className="form-group">
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', alignItems: 'center' }}>
                    <label style={{ fontWeight: '700', color: '#475569', margin: 0 }}>Preference Order {num}</label>
                    <label className="urdu-text" style={{ margin: 0, color: '#1d976c', fontWeight: 'bold', width: 'auto' }}>
                      {convertToUrduNumber(num)} ترجیح
                    </label>
                  </div>
                  <select
                    id={`pref${num}`}
                    name={`pref${num}`}
                    className="form-control-custom"
                    value={preferences[`pref${num}`]}
                    onChange={onChange}
                  >
                    {getOptionsForSelect(`pref${num}`)}
                  </select>
                </div>
              ))}
            </div>

            <div style={{ textAlign: 'center', marginTop: '50px', borderTop: '2px solid #f8fafc', paddingTop: '30px' }}>
              <p style={{ color: '#94a3b8', fontSize: '13px', marginBottom: '20px' }}>Please double-check your preferences before submitting.</p>

              <button
                type="submit"
                className="btn-home"
                disabled={loading}
                style={{ border: 'none', cursor: 'pointer', fontSize: '18px', display: 'inline-flex', alignItems: 'center', gap: '10px' }}
              >
                {loading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
                {loading ? "Processing..." : "Finalize & Submit Application"}
              </button>
            </div>
          </div>
        </form>
      )}
    </div>
  );
};

export default Page3;